<template>
  <div class="head-content">
    <div class="pc_header" v-if="isMaxScreen">
      <img
        src="../../assets/image/home/logo.png"
        @click="handleNav(5)"
        class="head-logo-icon"
        alt=""
      />
      <!-- <div class="nav-container">
        <div @click="handleNav(0)" class="nav-item">{{ $t('head.index.646nt7hwh0c0') }}</div>
        <div @click="handleNav(1)" class="nav-item">{{ $t('head.index.646ntjwmn580') }}</div>
        <div @click="handleNav(6)" class="nav-item">Blog</div>
        <div @click="handleNav(2)" class="nav-item">{{ $t('head.index.646nt7hwils0') }}</div>
      </div> -->
      <!-- <PC-order-step></PC-order-step> -->
      <div class="right-container">
        <!-- <div
          class="btn btn-buy"
          @mouseenter="handleMouseenter"
          @mouseleave="handleMouseleave(true)"
        >
          <img src="../../assets/image/eu-home/icon/buy.png" alt="" class="btn-icon buy-btn-icon" />
          {{ $t('head.index.646nt7hwipg0') }}
        </div>
        <div @click="handleNav(3)" class="btn btn-reclaim">
          <img src="../../assets/image/eu-home/icon/reclaim-white.png" alt="" class="btn-icon" />
          {{ $t('head.index.646nt7hwis00') }}
        </div> -->
        <!-- <language ref="language"></language> -->
      </div>
    </div>
    <div class="header" v-else>
      <div class="left-container">
        <div @click="goBack" class="back">
          <img src="@/assets/image/home/back-icon.png" alt="" />
          <!-- INICIO -->
        </div>
        <!-- <img
          v-if="showNav"
          @click="handleMenuIcon"
          src="../../assets/image/eu-home/icon/menu-close.png"
          alt=""
          class="btn-icon"
        />
        <img
          v-else
          @click="handleMenuIcon"
          src="../../assets/image/eu-home/icon/menu.png"
          alt=""
          class="btn-icon"
        />
        <img
          src="../../assets/image/home/logo.png"
          @click="handleNav(5)"
          class="head-logo-icon"
          alt=""
        /> -->
      </div>
      <div class="right-container">
        <!-- <img
          @click="handleNav(4)"
          src="../../assets/image/eu-home/icon/buy.png"
          alt=""
          class="btn-icon"
        />
        <img
          @click="handleNav(3)"
          src="../../assets/image/eu-home/icon/reclaim.png"
          alt=""
          class="btn-icon"
        /> -->

        <!-- <language ref="language" @handleSelectLanguage="handleSelectLanguage"></language> -->
      </div>
    </div>

    <transition v-if="showNav && !isMaxScreen" name="slide-fade">
      <div class="nav-container">
        <div @click="handleNav(0)" class="nav-item">
          <div class="nav-item-text">{{ $t('head.index.646nt7hwh0c0') }}</div>
          <img src="../../assets/image/eu-home/icon/right.png" alt="" class="nav-item-icon" />
        </div>
        <div @click="handleNav(1)" class="nav-item">
          <div class="nav-item-text">{{ $t('head.index.646ntjwmn580') }}</div>
          <img src="../../assets/image/eu-home/icon/right.png" alt="" class="nav-item-icon" />
        </div>
        <!-- 博客模块 -->
        <div @click="handleNav(6)" class="nav-item">
          <div class="nav-item-text">blog</div>
          <img src="../../assets/image/eu-home/icon/right.png" alt="" class="nav-item-icon" />
        </div>

        <div @click="handleNav(2)" class="nav-item">
          <div class="nav-item-text">{{ $t('head.index.646nt7hwils0') }}</div>
          <img src="../../assets/image/eu-home/icon/right.png" alt="" class="nav-item-icon" />
        </div>
      </div>
    </transition>

    <transition name="slide-fade">
      <div
        v-show="showSellerDialog"
        :class="isMaxScreen ? 'pc_seller-buy-dialog' : 'seller-buy-dialog'"
      >
        <div
          class="seller-buy-content-box"
          @mouseenter="handleMouseenter"
          @mouseleave="handleMouseleave(false)"
        >
          <div class="seller-buy-content">
            <div class="container">
              <div v-for="seller in sellerList" :key="seller.id" class="seller-buy-item">
                <img :src="seller.icon" alt="" class="seller-icon" />
                <div class="seller-text">{{ seller[isES ? 'estext' : 'entext'] }}</div>
                <div class="btn btn-buy" @click="handleToBuy(seller.url)">
                  {{ $t('head.index.646nt7hwipg0') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import language from '../../components/language';
import { isES, lang } from '@/locales';
import { mapState } from 'vuex';
import PCOrderStep from '@/components/PCOrderStep/it-index.vue';
export default {
  props: {
    isShowBack: {
      type: Boolean,
      default: false
    }
  },
  components: {
    language,
    PCOrderStep
  },
  data() {
    return {
      showNav: false,
      showSellerDialog: false,
      isES,
      lang,
      sellerList: [
        {
          id: 4,
          name: 'C',
          icon: require('../../assets/image/eu-home/seller/7.png'),
          estext: 'Tienda oficial eSwop',
          entext: 'eSwop official shop',
          url: 'https://eswop.shop/'
        },

        // {
        //   id: 2,
        //   name: 'PC',
        //   icon: require('../../assets/image/eu-home/seller/2.png'),
        //   estext: 'New & Refurbished Smartphones',
        //   entext: 'New & Refurbished Smartphones',
        //   url: ''
        // },
        {
          id: 3,
          name: 'amazon',
          icon: require('../../assets/image/eu-home/seller/3.png'),
          estext: 'Móviles reacondicionados',
          entext: 'Refurbished smartphones',
          url: 'https://www.amazon.es/s?me=A3DGLY3L3S927&marketplaceID=A1RKKUPIHCS9HS'
        },
        {
          id: 1,
          name: 'temu',
          icon: require('../../assets/image/eu-home/seller/1.png'),
          estext: 'Móviles reacondicionados',
          entext: 'Refurbished smartphones',
          url: 'https://www.temu.com/es/-north--m-670702092989814.html'
        },

        {
          id: 5,
          name: 'Back Market',
          icon: require('../../assets/image/eu-home/seller/5.png'),
          estext: 'Móviles de segunda mano',
          entext: 'Second-hand smartphones',
          url: ''
        }
        // {
        //   id: 6,
        //   name: 'Wallapop',
        //   icon: require('../../assets/image/eu-home/seller/6.png'),
        //   estext: 'Second-hand smartphones',
        //   entext: 'Second-hand smartphones',
        //   url: ''
        // }
      ],
      timer: null
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    })
  },
  mounted() {},
  methods: {
    goBack() {
      // var currentURL = window.location.href;
      // var queryString = currentURL.split('?')[1];
      // this.$router.push('/order?' + queryString);
      const currentRoute = this.$route;
  
      // 检查是否能返回
      if (this.$router.currentRoute.matched.length > 0 && window.history.length > 1) {
        this.$router.go(-1);
      } else {
        // 使用路由的name进行跳转，更稳定
        this.$router.push({
          path: '/order',
          query: currentRoute.query // 保持所有query参数
        });
      }
    },
    // 打开选择语言下拉框，点页面其他地方关闭下拉框
    hidLangeList() {
      this.$refs.language.showLanguageList && (this.$refs.language.showLanguageList = false);
    },
    handleMenuIcon() {
      this.showSellerDialog = false;
      this.showNav = !this.showNav;
    },
    handleNav(type) {
      this.showNav = false;

      const typeMaps = {
        0: {
          path: '/home/whoAreWe',
          name: 'WhoAreWe'
        },
        1: {
          path: '/home/business',
          name: 'Business'
        },
        2: {
          path: '/home',
          name: 'Home'
        },
        3: {
          path: '/product',
          name: 'Product'
        },
        4: {
          path: '',
          name: ''
        },
        5: {
          path: '/order',
          name: 'order'
        },
        6: {
          path: '/blogList',
          name: 'blogList'
        }
      };

      const { path, name } = typeMaps[type];
      if (type === 2) {
        // 联系我们
        if (this.$route.path === path) {
          // 在home页面直接定位
          this.scrollToAnchor('section-7');
        } else {
          this.$router.replace({ name });
          setTimeout(() => {
            this.scrollToAnchor('section-7');
          }, 800);
        }
      } else if (type === 4) {
        // 去购买
        this.showSellerDialog = !this.showSellerDialog;
      } else if (type === 6) {
        // blog
        this.$router.push({ name });
      } else {
        // 关于eSwop、Business、去回收
        if (this.$route.path === path) {
          window.location.reload();
        } else {
          this.$router.push({ name });
        }
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 500);
      }
    },
    scrollToAnchor(anchorId) {
      const element = document.getElementById(anchorId);
      if (element) {
        const options = { behavior: 'smooth', block: 'start' };
        element.scrollIntoView(options);
      }
    },
    handleMouseenter() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.showNav = false;
      this.showSellerDialog = true;
    },
    handleMouseleave(value) {
      if (value) {
        this.timer = setTimeout(() => {
          this.showSellerDialog = false;
        }, 200);
      } else {
        this.showSellerDialog = false;
      }
    },
    handleToBuy(url) {
      if (url) {
        window.open(url);
      } else {
        // window.open('https://www.baidu.com/');
      }
    },
    handleSelectLanguage() {
      this.showNav = false;
      this.showSellerDialog = false;
    }
  }
};
</script>

<style scoped lang="less">
@media (min-width: 981px) {
  .head-content {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 999;
    .pc_header {
      height: 100px;
      max-width: 1400px;
      margin: auto;
      display: flex;
      align-items: center;
      background-color: #fff;
      justify-content: space-between;
      position: relative;
      .head-logo-icon {
        width: 165px;
        height: 30px;
        flex-shrink: 0;
        cursor: pointer;
      }
      .nav-container {
        display: flex;
        justify-content: center;
        align-items: center;
        .nav-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 16px 20px 12px 20px;
          color: #5d5f65;
          font-family: 'PingFang SC';
          font-size: 16px;
          font-weight: 400;
          cursor: pointer;
          position: relative;
          &:hover {
            color: #252629;
            font-weight: 600;
            &::after {
              content: '';
              display: block;
              height: 3px;
              width: 50%;
              background: #4a4a4a;
              position: absolute;
              bottom: 0;
            }
          }
        }
      }
      .right-container {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;
        .btn {
          display: flex;
          padding: 14px 24px;
          align-items: center;
          gap: 4px;
          border-radius: 8px;
          font-family: 'PingFang SC';
          font-size: 16px;
          cursor: pointer;
          .btn-icon {
            width: 20px;
            height: 20px;
          }
        }
        .btn-buy {
          background: #f4f5f7;
          color: #252629;
          &:hover {
            background: rgba(255, 150, 0, 0.08);
            color: #ff9600;
            img {
              content: url(../../assets/image/eu-home/icon/buy-active.png);
            }
          }
        }
        .btn-reclaim {
          background: #ff9600;
          color: #fff;
        }
      }
    }
    .pc_seller-buy-dialog {
      position: absolute;
      z-index: 999;
      width: 100%;
      height: calc(100vh - 100px);
      background: rgba(0, 0, 0, 0.6);
      .seller-buy-content-box {
        background: #fff;
        padding-bottom: 80px;
        margin: auto;
        .seller-buy-content {
          max-width: 1400px;
          margin: auto;
          .container {
            display: grid;
            grid-template-columns: 1fr 1fr;
            .seller-buy-item {
              width: 260px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              margin-top: 80px;
              // 3个一行
              // &:nth-child(3n-2) {
              //   // 1/4/7/10...
              //   place-self: start;
              // }
              // &:nth-child(3n-1) {
              //   // 2/5/8//11...
              //   place-self: center;
              // }
              // &:nth-child(3n) {
              //   // 3/6/9//12...
              //   place-self: end;
              // }

              // 2个一行
              place-self: center;

              .seller-icon {
                height: 48px;
                flex-shrink: 0;
              }
              .seller-text {
                color: #252629;
                text-align: center;
                font-family: 'PingFang SC';
                font-size: 24px;
                font-style: normal;
                font-weight: 600;
                // line-height: 150%;
                margin: 12px 0 24px;
                word-break: break-word;
              }
              .btn {
                display: flex;
                padding: 13px 36px;
                align-items: center;
                border-radius: 8px;
                font-family: 'PingFang SC';
                font-size: 16px;
                background: #f4f4f4;
                color: #000;
                cursor: pointer;
                &:hover {
                  background: #ff9600;
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 980px) {
  .head-content {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 999;
    .back {
      width: 120px;
      height: 48px;
      display: flex;
      align-items: center;
      color: #ff9600;
      img {
        width: 48px;
        height: 48px;
      }
    }
    .header {
      height: 100px;
      padding: 0 30px;
      display: flex;
      align-items: center;
      background-color: #fff;
      justify-content: space-between;
      position: relative;
      border-bottom: 1px solid #ebebeb;
      .left-container {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 32px;
        .head-logo-icon {
          width: 160px;
          height: 40px;
          flex-shrink: 0;
          cursor: pointer;
        }
      }
      .right-container {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 32px;
      }
      .btn-icon {
        width: 48px;
        height: 48px;
      }
    }
    .nav-container {
      position: absolute;
      z-index: 999;
      width: 100%;
      height: calc(100vh - 100px);
      background: #fff;
      .nav-item {
        display: flex;
        padding: 18px 30px;
        justify-content: space-between;
        align-items: center;
        align-self: stretch;
        color: #252629;
        font-family: 'PingFang SC';
        font-size: 32px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        .nav-item-icon {
          width: 48px;
          height: 48px;
        }
      }
    }
    .seller-buy-dialog {
      position: absolute;
      z-index: 999;
      width: 100%;
      height: calc(100vh - 100px);
      background: #fff;
      .seller-buy-content-box {
        .seller-buy-content {
          margin: auto;
          width: calc(100% - 60px);
          padding: 48px 30px;
          .container {
            display: grid;
            grid-template-columns: 1fr 1fr;
            .seller-buy-item {
              width: 325px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              margin-top: 64px;

              .seller-icon {
                height: 67px;
                flex-shrink: 0;
              }
              .seller-text {
                padding: 0 28px;
                color: #252629;
                text-align: center;
                font-family: 'PingFang SC';
                font-size: 20px;
                font-style: normal;
                font-weight: 600;
                line-height: 150%;
                margin: 22px 0 36px;
              }
              .btn {
                display: flex;
                padding: 18px 34px;
                align-items: center;
                gap: 5px;
                border-radius: 11px;
                font-family: 'PingFang SC';
                font-size: 20px;
                cursor: pointer;
                background: #f4f5f7;
                color: #000;
                &:hover {
                  background: #ff9600;
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
